import { apiDocTranslations } from './apiDocI18n';

const baseTranslations = {
  'zh-CN': {
    // 通用
    login: '登录', logout: '退出', username: '用户名', password: '密码',
    welcome: '欢迎', refresh: '刷新', reset: '重置', search: '查询',
    execute: '执行测试', loading: '加载中...', success: '成功', failed: '失败',
    confirm: '确定', cancel: '取消', edit: '编辑', delete: '删除',
    create: '创建', update: '更新', save: '保存', close: '关闭',
    export: '导出', detail: '详情', operation: '操作', optional: '可选',
    submit: '提交', back: '返回', enable: '启用', disable: '禁用',
    yes: '是', no: '否', all: '全部',

    // 导航 & 标题
    testPlatform: '金丝雀测试平台',
    dashboard: '数据看板',
    testExecutor: '测试执行',
    executionHistory: '执行历史',
    accountCreate: '开户',
    accountQuery: '账户查询',
    payin: '充值',
    payinQuery: '充值单查询',
    payout: '提现',
    payoutQuery: '提现单查询',
    refundPage: '退款',
    refundQuery: '退款单查询',
    bankCardBind: '银行账户绑定',
    bankAccountQuery: '银行账户信息查询',
    orderListQuery: '订单列表查询',
    userManagement: '用户管理',
    channelAccountManagement: '渠道账户管理',
    personalSettings: '个人设置',
    secureLogin: '安全登录',
    channelTestPlatform: '渠道测试平台',
    loginTitle: '金丝雀测试平台',
    loginSubtitle: '法币渠道测试',

    // 表单字段
    channel: '渠道', environment: '环境', testType: '测试类型',
    businessPartner: 'businessPartner', currency: '币种', amount: '金额',
    requestBody: '请求体', formMode: '表单模式', jsonMode: 'JSON模式',
    idempotentTest: '幂等测试', channelCode: '渠道代码',
    selectChannel: '选择渠道', selectCurrency: '选择币种',
    accountId: '账户ID', recipientId: '收款人ID', orderId: '订单ID',
    requestId: 'Request ID', externalUserId: '外部用户ID',
    externalOrderId: '外部订单ID', userType: '用户类型',
    paymentMethod: '支付方式', firstName: '名', middleName: '中间名',
    lastName: '姓', phone: '手机号', dob: '生日', email: '邮箱',
    depositMethod: '充值方式', withdrawMethod: '提现方式',
    callbackUrl: '回调地址', accountName: '账户名', bic: 'BIC/SWIFT',
    accountNumber: '账号', bankName: '银行名称', purpose: '用途',
    bankCountry: '银行国家',
    fullName: '全名', bankIdentifier: '银行标识', virtualAccountName: '虚拟账户名',
    ninNumber: 'NIN号码', bvnNumber: 'BVN号码', mobile: '手机号',
    country: '国家', city: '城市', street: '街道', number: '门牌号', postalCode: '邮编',
    corporateType: '企业类型', idType: '证件类型', idNumber: '证件号',
    nationality: '国籍', residenceCountry: '居住国/注册国',
    residenceCity: '居住城市/注册城市', residenceAddress: '居住地址/注册地址',
    pixKeyType: 'PIX Key类型', targetCurrency: '目标币种', targetAmount: '目标金额',
    calOrigin: '计算方向', rateId: 'Rate ID', description: '转账描述',
    pobo: 'POBO', chargeType: '手续费承担', name: '用户名字', orderType: '订单类型', orderStatus: '订单状态',
    businessType: '业务类型', transTime: '交易时间', refund: '退款',
    timeRange: '时间范围', allStatuses: '全部状态',
    basicConfig: '基础配置', queryConditions: '查询条件', queryResults: '查询结果',

    // 测试类型
    ACCOUNT_CREATE: '开户', PAYIN: '充值', PAYOUT: '提现',
    CARD_BIND: '绑卡', QUERY: '查询', CALLBACK: '回调',
    deposit: '充值', withdraw: '提现',

    // 结果 & 状态
    executionResult: '执行结果', status: '状态', costTime: '耗时',
    httpStatus: 'HTTP状态', traceId: '追踪ID', channelOrderId: '渠道订单号',
    errorMsg: '错误信息', errorCode: '错误码', errorDetail: '错误详情',
    request: '请求', response: '响应', subStatus: '子状态',
    fee: '手续费', createTime: '创建时间', updateTime: '更新时间',
    completedTime: '完成时间', refundStatus: '退款状态',

    // 执行历史
    executionId: '执行ID', executor: '执行人', executionTime: '执行时间',
    filterConditions: '筛选条件', startTime: '开始时间', endTime: '结束时间',
    executionDetail: '执行详情', requestParams: '请求参数', responseResult: '响应结果',
    totalRecords: (n) => `共 ${n} 条记录`,
    rangeRecords: (s, e, t) => `第 ${s}-${e} 条，共 ${t} 条记录`,

    // 消息提示
    loginSuccess: '登录成功', loginFailed: '登录失败',
    executeSuccess: '测试执行成功', executeFailed: '测试执行失败',
    loadConfigFailed: '加载配置失败', querySuccess: '查询成功', queryFailed: '查询失败',
    createSuccess: '创建成功', updateSuccess: '更新成功', deleteSuccess: '删除成功',
    operationFailed: '操作失败', loadFailed: '加载失败',
    bindSuccess: '绑定成功', bindFailed: '绑定失败',
    accountUnlocked: '账户已自动解锁',
    twoFAEnabled: '2FA启用成功！下次登录将需要验证码',
    twoFADisabled: '2FA已禁用',
    twoFAEnableFailed: '启用2FA失败', twoFAVerifyFailed: '验证失败',
    twoFADisableFailed: '禁用失败',

    // 校验提示
    usernameRequired: '请输入用户名', passwordRequired: '请输入密码',
    pleaseInputChannelCode: '请选择渠道代码', pleaseSelectTimeRange: '请选择时间范围',
    pleaseInput: (field) => `请输入${field}`, pleaseSelect: (field) => `请选择${field}`,
    autoGenerate: '留空则自动生成',

    // 登录页
    accountLocked: '账户已锁定',
    accountLockedDesc: (min) => `由于多次登录失败，您的账户已被锁定。请${min}分钟后再试，或联系管理员解锁。`,
    loginFailedTimes: (n) => `登录失败${n}次`,
    remainingAttempts: (n) => `还剩${n}次机会，超过5次将锁定账户15分钟`,
    twoFAVerification: '双因素验证',
    twoFADesc: '请打开您的身份验证器应用，输入6位验证码',
    securityTip: '安全提示',
    securityTipDesc: '• 密码至少8位，包含大小写字母、数字、特殊字符\n• 连续5次登录失败将锁定账户15分钟',
    lockedButton: (min) => `账户已锁定 (${min}分钟)`,
    loggingIn: '登录中...',
    verifying: '验证中...',
    verify: '验证',
    backToLogin: '返回登录',
    backToConsole: '返回控制台',
    enterCaptcha: '请输入验证码',
    captchaRequired: '请输入验证码',
    enter6DigitCode: '请输入6位验证码',
    require2FA: '请输入双因素验证码',

    // 开户
    accountCreateParams: '开户参数',
    accountCreateSuccess: '开户成功', accountCreateFailed: '开户失败',
    creatingAccount: '开户中...', createAccount: '创建账户',
    accountCreateResult: '开户结果', submitToShowResult: '提交表单后将显示开户结果',
    selectChannelFirst: '请先选择渠道', noChannelConfig: '该渠道暂无配置',

    // 充值
    payinParams: '充值参数', payinSuccess: '充值请求成功', payinFailed: '充值失败',
    paying: '充值中...', submitPayin: '发起充值', payinResult: '充值结果',
    submitToShowPayinResult: '提交表单后将显示充值结果',
    switchChannel: '切换渠道',

    // 提现
    payoutParams: '提现参数', payoutSuccess: '提现请求成功', payoutFailed: '提现失败',
    payingOut: '提现中...', submitPayout: '发起提现', payoutResult: '提现结果',
    submitToShowPayoutResult: '提交表单后将显示提现结果',
    extParams: '扩展参数',

    // 银行账户绑定
    channelConfig: '渠道配置', accountHolder: '账户持有人',
    bankAccountInfo: '银行账户信息', holderType: '持有人类型',
    accountType: '账户类型', binding: '绑定中...', bindBankAccount: '绑定银行账户',
    bindResult: '绑定结果', submitToShowBindResult: '提交表单后将显示绑定结果',
    noAccountData: '暂无账户数据，请先开户',
    noCardData: '暂无绑卡数据，请先绑定银行账户',

    // 查询页通用
    enterToQuery: (field) => `请输入${field}进行查询`,
    resetBtn: '重置',

    // 账户查询
    accountStatus: '账户状态', accountDetail: '账户详情',
    bankAccountInfo2: '银行账户信息', operationTimeline: '操作时间线',
    accountUpdated: '账户更新', accountCreated: '账户创建',
    enterAccountId: '请输入账户ID进行查询',

    // 充值单查询
    payinOrderId: '充值单ID', payinStatus: '充值状态',
    payinOrderDetail: '充值单详情', payinOrderTimeline: '充值单时间线',
    payinCompleted: '充值完成', payinProcessing: '充值处理中',
    orderCreated: '订单创建', callbackConfig: '回调配置',
    successRedirect: '成功跳转', failRedirect: '失败跳转',
    enterPayinOrderId: '请输入充值单ID进行查询',
    channelPayinOrderId: '渠道中台充值单ID',

    // 提现单查询
    payoutOrderId: '提现单ID', payoutStatus: '提现状态',
    payoutAmount: '提现金额', payoutOrderDetail: '提现单详情',
    payoutOrderTimeline: '提现单时间线', payoutCompleted: '提现完成',
    payoutProcessing: '提现处理中', externalPayoutOrderId: '外部提现单ID',
    channelPayoutOrderId: '渠道中台提现单ID',
    enterPayoutOrderId: '请输入提现单ID进行查询',

    // 退款
    refundPage: '退款', refundQuery: '退款单查询',
    refundParams: '退款参数', refundSuccess: '退款请求成功', refundFailed: '退款失败',
    refunding: '退款中...', submitRefund: '发起退款', refundResult: '退款结果',
    submitToShowRefundResult: '提交表单后将显示退款结果',
    depositOrderId: '源充值订单ID',

    // 退款单查询
    refundOrderId: '退款单ID', refundQueryStatus: '退款状态',
    refundAmount: '退款金额', refundOrderDetail: '退款单详情',
    refundOrderTimeline: '退款单时间线', refundCompleted: '退款完成',
    refundProcessing: '退款处理中', externalRefundOrderId: '外部退款单ID',
    channelRefundOrderId: '渠道中台退款单ID',
    enterRefundOrderId: '请输入退款单ID进行查询',

    // 银行账户查询
    bankAccountDetail: '银行账户详情',
    enterRecipientId: '请输入Recipient ID进行查询',
    queryBankAccount: '查询银行账户信息',

    // 订单列表
    totalCount: (n) => `共 ${n} 条记录`,

    // Dashboard
    totalExecutions: '总执行次数', successRate: '成功率', avgResponseTime: '平均响应时间',
    todayExecutions: '今日执行', successCount: '成功', failedCount: '失败',
    testTypeDistribution: '操作类型分布', channelDistribution: '渠道分布',
    statusDistribution: '状态分布', dailyTrend: '每日执行趋势（近30天）',
    responseTimeDistribution: '响应时间分布', channelSuccessRate: '渠道成功率',
    channelTestTypeHeatmap: '渠道 × 操作类型', executorLeaderboard: '执行者排行榜',
    channelGlobalMap: '渠道全球分布',
    exportReport: '导出报告', lockLayout: '锁定布局', unlock: '解锁布局',
    currencyDistribution: '币种分布', envDistribution: '环境分布',
    pvUvTrend: 'PV/UV 趋势（近30天）', hourlyDistribution: '小时分布',
    channelStatusDistribution: '渠道 × 状态', channelRadar: '渠道雷达图',
    recentExecutions: '最近执行记录',
    noData: '暂无执行数据',

    // 用户管理
    userId: '用户ID', role: '角色', userStatus: '状态',
    channelPermissions: '渠道权限', noPermission: '无权限', allPermissions: '全渠道权限',
    admin: '管理员', normalUser: '普通用户',
    internalUser: '内部', externalUser: '外部',
    active: '激活', disabled: '禁用',
    createUser: '创建用户', editUser: '编辑用户',
    confirmDelete: '确定将该用户设为失效？', confirmActivate: '确定重新激活该用户？',
    deactivate: '失效', activate: '激活',
    deactivateSuccess: '用户已失效', activateSuccess: '用户已激活',
    passwordStrengthWeak: '弱', passwordStrengthMedium: '中等', passwordStrengthStrong: '强',
    passwordRequirements: '密码要求：8-32位，必须包含大小写字母、数字和特殊字符',
    atLeast8Chars: '至少8位', includeUppercase: '包含大写字母',
    includeLowercase: '包含小写字母', includeNumber: '包含数字',
    includeSpecial: '包含特殊字符',
    uidTooltip: '系统自动生成，格式：U+日期+序号',
    usernameMin3: '用户名至少3个字符',
    passwordMin8: '密码至少8位', passwordMax32: '密码最多32位',
    passwordMustUppercase: '密码必须包含大写字母',
    passwordMustLowercase: '密码必须包含小写字母',
    passwordMustNumber: '密码必须包含数字',
    passwordMustSpecial: '密码必须包含特殊字符 (!@#$%^&*(),.?":{}|<>_-)',
    checkForm: '请检查表单填写',
    loadUsersFailed: '加载用户列表失败',

    // 渠道账户管理
    clientType: '客户端类型', localAccountNo: '本地账号', channelAccountNo: '渠道账号',
    customerId: '客户ID', priority: '优先级', copyToDemo: '复制到DEMO_ACCOUNT',
    allChannels: '所有渠道',
    cloneToDemo: '克隆到 DEMO_ACCOUNT?',
    confirmDisableAccount: '禁用',
    confirmEnableAccount: '启用',
    endpoint: '接口地址',
    timeoutMs: '超时(ms)',
    signAlgorithm: '签名算法',
    selectAlgorithm: '选择算法',
    channelPublicKey: '渠道公钥',
    extraConfig: '扩展配置',
    security: '安全配置',

    // 渠道用户管理
    channelUserManagement: '渠道用户管理',
    createUserTab: '创建用户',
    queryUserTab: '查询用户',
    basicInfo: '基础信息',
    channelLabel: '渠道',
    selectChannelPlaceholder: '选择渠道',
    userTypeLabel: '用户类型',
    individualUser: 'INDIVIDUAL (个人)',
    businessUser: 'BUSINESS (企业)',
    externalUserIdLabel: '外部用户ID',
    pleaseInputExternalUserId: '请输入外部用户ID',
    currencyLabel: '币种',
    selectCurrencyPlaceholder: '选择币种',
    extParamSection: '扩展参数',
    extParamTooltip: 'JSON 格式的渠道扩展参数',
    createUserBtn: '创建用户',
    creatingUser: '创建中...',
    createResultTitle: '创建结果',
    submitToShowCreateResult: '提交表单后将显示创建结果',
    queryConditionsSection: '查询条件',
    externalUserIdTooltip: 'externalUserId 和 userId 至少填一个',
    userIdLabel: '用户ID',
    userIdTooltip: 'fiat-payment 内部用户ID',
    queryUserBtn: '查询用户',
    queryingUser: '查询中...',
    queryResultTitle: '查询结果',
    submitToShowQueryResult: '提交查询后将显示结果',
    userCreateSubmitted: '用户创建请求已提交',
    userCreateFailed: '创建失败',
    userQueryFailed: '查询失败',
    unknownError: '未知错误',
    // Tazapay KYB
    tzCompanyBasicInfo: '企业基础信息',
    tzIndustry: '行业 (industry)',
    tzIndustryRequired: '必填，不填会被渠道拦截',
    tzTaxId: '税号',
    tzPhoneLabel: '电话',
    tzPhoneCode: '区号',
    tzWebsite: '网站',
    tzBusinessDesc: '业务描述',
    tzKybCompanyInfo: 'KYB 公司信息',
    tzCompanyTypeLabel: '公司类型',
    tzCompanyNameLabel: '公司名称',
    tzRegNo: '注册号',
    tzEstablishDate: '成立日期',
    tzSelectDate: '选择日期',
    tzStatementDesc: '报表描述符',
    tzRegisterAddress: '注册地址',
    tzOperationAddress: '运营地址',
    tzCompanyDocs: '企业文档',
    tzFileType: '文件类型',
    tzLinkedFile: '关联文件',
    tzSelectUploadedFile: '选择已上传文件',
    tzFileName: '文件名',
    tzFileDesc: '描述',
    tzAddDoc: '添加文档',
    tzLegalInfo: '法人/董事信息',
    tzRepresentative: '代表人',
    tzFirstName: '名',
    tzLastName: '姓',
    tzNationality: '国籍',
    tzDob: '出生日期',
    tzSelectDob: '请选择出生日期',
    tzRole: '角色',
    tzOwnership: '持股%',
    tzResidentialAddress: '居住地址',
    tzRepDocs: '代表人文档',
    tzAddRepDoc: '添加文档',
    tzAddRepresentative: '添加代表人',
    tzTransactionProfile: '交易概况 (可选)',
    tzMonthlyValue: '月交易金额',
    tzMonthlyVolume: '月交易笔数',
    tzCountries: '交易国家',
    tzRiskLevel: '风险等级',
    tzAddressCountry: '国家',
    tzAddressState: '州/省',
    tzAddressCity: '城市',
    tzAddressPostcode: '邮编',
    tzAddressLine1: '地址行1',

    // 汇率查询 (Quote)
    quoteTitle: '汇率查询',
    quoteBasicInfo: '基础信息',
    quoteOriginCurrency: '原始币种',
    quoteTargetCurrency: '目标币种',
    quotePayeeType: '收款人类型',
    quoteAmount: '金额 (分)',
    quoteAmountTip: '金额单位为最小货币单位（如分/cents）',
    quoteUserInfo: '用户信息',
    quoteUserId: '用户ID',
    quoteUserIdTip: 'payeeType=BENEFICIARY 时必填',
    quoteExternalUserId: '外部用户ID',
    quoteAdvanced: '高级选项',
    quoteDestCountry: '目标国家',
    quoteLocalNetwork: '本地支付网络',
    quoteFundNetwork: '资金转账网络',
    quoteQueryBtn: '查询汇率',
    quoteResultTitle: '查询结果',
    quoteExchangeRate: '汇率',
    quoteExpireTime: '过期时间',
    quoteEmptyHint: '提交查询后将显示汇率结果',

    // 银行绑定扩展参数
    recipientAddress: '收款人地址', recipientCity: '收款人城市',
    recipientPostalCode: '收款人邮编', recipientCountry: '收款人国家',
    routeAba: 'Route ABA', routeType: '路由类型',
    payeeType: '收款人类型', payeeCompanyName: '收款公司名称',
    payeeEmail: '收款人邮箱', payeePhone: '收款人电话',
    payeeCountry: '收款人国家', payeeStreetAddress: '收款人街道地址',
    payeeCity: '收款人城市', bankAddress: '银行地址', bankCity: '银行城市',
    bankState: '银行州/省', branchCode: '支行代码', bankCode: '银行代码',
    contactDocuments: '联系文件', bankStatement: '银行流水',
    clearingNetwork: '清算网络', financialInstitution: '金融机构 (BIC)',
    creditorAddressLine1: '债权人地址',
    rfc: 'RFC 税号', numericRef: '数字参考号', notesRef: '备注',

    // 字段 Tooltip Tips
    tipBusinessName: 'BUSINESS时填公司名称拆解',
    tipDobFormat: '格式：ddMMyyyy',
    tipIdType: 'P=护照 N=身份证(仅INDIVIDUAL)',
    tip3LetterCountry: '3位国家码',
    tipCorporateType: '仅BUSINESS需要',
    tipBankIdentifierFromCard: '从卡列表获取',
    tipBankIdentifierFromList: '从银行列表获取',
    tipVirtualAccountName: '自定义户名，必填字段',
    tipKycKybName: 'KYC用户传个人姓名，KYB用户传企业名称',
    tipNinNumber: 'personal_nin类型时使用，必须为11位数字',
    tipBvnNumber: 'KYC用户传本人BVN，KYB用户传董事BVN，必须为11位数字',
    tipVaDisplayName: 'VA账户显示名称',
    tipEmailOrMobile: 'email和mobile至少填一个',
    tipBitsoVirtualAccount: 'BITSO 仅支持 VIRTUAL_ACCOUNT',
    tipRecipientIdFromPayment: '由 fiat-payment 返回的 recipientId',
    tipRecipientIdFromBind: '绑卡返回的 recipientId',
    tipPurposeLength3: '提现目的，长度必须=3',
    tipDescriptionMax32: '长度不超过32位',
    tipCalOrigin: 'TARGET2ORIGIN: 到账金额=targetAmount; ORIGIN2TARGET: 支付金额=amount',
    tipRateId: '跨币种时传入',
    tipDescriptionMax100: '长度100以内',
    tipPobo: '仅RTGS支持，传Y代表收款姓名显示为自己',
    tipChargeType: 'BEN:收款人承担 OUR:付款人承担 SHA:双方分摊',
    tipBitsoWithdrawMethod: 'BITSO 仅支持 BANK_TRANSFER',
    tipRfc: '收款人税号，必填',
    tipNumericRef: '可选，最长7位数字',
    tipNotesRef: '可选，最长40字符',
    tipPixKeyOrBankCode: 'PIX Key或银行代码',
    tipClabe: 'CLABE必须为18位数字，必填',
    tipClabeByProtocol: (p) => p === 'debitcard' ? '传借记卡号' : p === 'phonenum' ? '传手机号' : 'CLABE必须为18位数字',
    tipProtocol: '默认 clabe；debitcard=借记卡；phonenum=手机号',
    tipBankCodeDebitcard: 'protocol=debitcard 时必填',

    // Inswitch Tips
    tipInswitchVirtualAccount: '仅支持 VIRTUAL_ACCOUNT，仅支持 BRL',
    tipInswitchIdType: '个人用户传CPF（巴西个人税号），企业用户传CNPJ（巴西企业税号）',
    tipInswitchDocNumber: 'userType为INDIVIDUAL时传CPF号（11位纯数字），userType为BUSINESS时传CNPJ号（14位纯数字）',
    tipInswitchBirthDate: 'INDIVIDUAL时为出生日期，BUSINESS时为公司成立日期。格式: YYYY-MM-DD（如1994-08-15）',
    tipInswitchCountryCode2: 'INDIVIDUAL时为出生国家，BUSINESS时为公司成立国家。2位大写国家码（如巴西=BR）',
    tipInswitchCompanyName: 'BUSINESS用户必填，INDIVIDUAL用户不传',
    tipInswitchCompanyType: 'BUSINESS用户必填，INDIVIDUAL用户不传。可选值：Professional Services and Consulting / Technology and Digital Platforms / Commerce, Import/Export, and E-commerce / Logistics, Transportation, and Related Services / Education, Entertainment, and Miscellaneous Services / Financial Transactions and Investments',
    tipInswitchWithdrawMethod: '仅支持 PIX_CODE',
    tipInswitchPixKey: 'PIX收款标识，必填，可为邮箱/CPF/手机号/UUID随机密钥',
    tipInswitchDepositDocType: 'INSWITCH 仅支持 BRL 与 MXN。BRL 传 CPF（个人）/CNPJ（企业），MXN 传 ruc（RFC 税号）',
    tipInswitchDepositDocNumber: 'BRL: CPF 11位纯数字 / CNPJ 14位纯数字；MXN: RFC 税号（按渠道正则校验）',
    tipInswitchDepositName: 'BRL 必填且校验姓名正则；MXN 在 entityType=naturalPerson 时必填',
    tipInswitchEntityType: '墨西哥(MXN)必填：naturalPerson(自然人，需 firstName/lastName) / legalEntity(法人，需 companyName/companyType)',
    tipInswitchClabe: '墨西哥(MXN) SPEI 收款核心标识，18位 CLABE 账号，必填',
    tipInswitchNameRule: '开户时INDIVIDUAL必填、BUSINESS可不传；提现时必填。Match pattern: ^[A-Za-z âÂãÃāĀÁáçÇêÊÉéÍíÕõÔôÓóÚúÀàÈèÌìÒòÙùǸǹẀẁỲỳñÑüÜ.\']+$（支持葡萄牙语特殊字符）',
    tipInswitchSecondLastname: '可选，第二姓（拉美常见）。Match pattern: 同姓名字段',
    tipInswitchEmail: '可选。Match pattern: ^[0-9A-Za-z\\-_\\.]+@([0-9A-Za-z\\-_]+\\.)+[0-9A-Za-z\\-_]{2,5}$',
    tipInswitchPhone: '可选，纯数字。Match pattern: ^\\d{4,15}$（4-15位）',
    tipInswitchAddress: 'INDIVIDUAL时为居住地址，BUSINESS时为公司注册地址。Match pattern: ^[0-9A-Za-z âÂãÃ...ñÑüÜ.,\']+$（支持数字、字母、葡萄牙语字符、标点）',
    tipInswitchWithdrawAmount: '金额必须大于0，精确到2位小数',
    tipInswitchCallbackUrl: '提现时必填',

    birthDate: '出生日期', birthCountry: '出生国家', address: '地址',
    countryCode: '国家代码', companyName: '公司名称', companyType: '公司类型',
    documentType: '证件类型', documentNumber: '证件号', pixKey: 'PIX Key',
    secondLastname: '第二姓', email: '邮箱', phoneNumber: '手机号',

    // BITSO 字段
    protocol: '协议类型', clabe: 'CLABE 号', bankCode: '银行代码',
    clabeAccountNo: 'CLABE / 卡号 / 手机号',

    // 2FA
    enable2FA: '启用双因素认证', disable2FA: '禁用双因素认证',
    twoFATitle: '启用双因素认证 (2FA)',
    twoFAScanDesc: '请使用 Google Authenticator 或其他 TOTP 应用扫描二维码',
    twoFAStep1: '步骤 1: 使用 Google Authenticator 或其他 TOTP 应用扫描二维码',
    twoFAStep2: '步骤 2: 输入应用中显示的6位验证码',
    manualKey: '密钥（手动输入）', manualKeyDesc: '密钥（如无法扫码，可手动输入）',
    verifyAndEnable: '验证并启用', confirmDisable: '确认禁用',
    twoFAProtection: '双因素认证为您的账户提供额外的安全保护。启用后，登录时需要输入手机应用生成的6位验证码。',
    twoFARecommend: '推荐使用：Google Authenticator、Microsoft Authenticator、Authy 等应用',
    twoFAEnabled2: '已启用', twoFADisabled2: '未启用',
    disableTwoFADesc: '禁用双因素认证将降低您的账户安全性。请输入当前的6位验证码以确认操作。',
    enter6Code: '请输入6位验证码',
    // SenderInfo
    senderInfo: '付款人信息',
    senderIban: '付款人账号',
    senderAcctName: '付款人账户名',
    senderBic: '付款银行',
    paymentInfo: '支付信息',
    openPaymentPage: '点击打开支付页面',
    scanToPay: '扫描二维码完成支付',

    // Mock Rules
    mockRules: 'Mock 规则管理',
    mockRuleTotal: '规则总数',
    mockRuleEnabled: '已启用',
    mockRuleDisabled: '已禁用',
    mockRuleChannels: '渠道数',
    mockRuleFilterChannel: '按渠道筛选',
    mockRuleSearchPlaceholder: '搜索路径 / 描述...',
    mockRuleRefreshCache: '刷新缓存',
    mockRuleNewRule: '新建规则',
    mockRuleEditRule: '编辑规则',
    mockRuleCreateRule: '创建规则',
    mockRulePathPattern: '接口路径（正则）',
    mockRuleDescription: '规则描述',
    mockRuleHttpStatus: 'HTTP 状态码',
    mockRulePriority: '优先级',
    mockRuleExpireTime: '过期时间',
    mockRuleNeverExpire: '永不过期',
    mockRuleMockResponse: 'Mock 响应（JSON）',
    mockRuleResponsePreview: '响应预览',
    mockRuleActions: '操作',
    mockRuleDuplicate: '复制',
    mockRuleConfirmDelete: '确定删除该规则？',
    mockRuleTotalRules: (n) => `共 ${n} 条规则`,
    mockRuleNoData: '暂无 Mock 规则',
  },

  'en-US': {
    // Common
    login: 'Login', logout: 'Logout', username: 'Username', password: 'Password',
    welcome: 'Welcome', refresh: 'Refresh', reset: 'Reset', search: 'Search',
    execute: 'Execute Test', loading: 'Loading...', success: 'Success', failed: 'Failed',
    confirm: 'Confirm', cancel: 'Cancel', edit: 'Edit', delete: 'Delete',
    create: 'Create', update: 'Update', save: 'Save', close: 'Close',
    export: 'Export', detail: 'Detail', operation: 'Action', optional: 'Optional',
    submit: 'Submit', back: 'Back', enable: 'Enable', disable: 'Disable',
    yes: 'Yes', no: 'No', all: 'All',

    // Navigation & Titles
    testPlatform: 'Canary Test Platform',
    dashboard: 'Dashboard',
    testExecutor: 'Test Executor',
    executionHistory: 'Execution History',
    accountCreate: 'Account Create',
    accountQuery: 'Account Query',
    payin: 'Deposit',
    payinQuery: 'Deposit Order Query',
    payout: 'Withdraw',
    payoutQuery: 'Withdraw Order Query',
    refundPage: 'Refund',
    refundQuery: 'Refund Order Query',
    bankCardBind: 'Bank Account Bind',
    bankAccountQuery: 'Bank Account Query',
    orderListQuery: 'Order List Query',
    userManagement: 'User Management',
    channelAccountManagement: 'Channel Account Management',
    personalSettings: 'Personal Settings',
    secureLogin: 'Secure Login',
    channelTestPlatform: 'Channel Test Platform',
    loginTitle: 'Canary Test Platform',
    loginSubtitle: 'Fiat Channel Testing',

    // Form Fields
    channel: 'Channel', environment: 'Environment', testType: 'Test Type',
    businessPartner: 'Business Partner', currency: 'Currency', amount: 'Amount',
    requestBody: 'Request Body', formMode: 'Form Mode', jsonMode: 'JSON Mode',
    idempotentTest: 'Idempotent Test', channelCode: 'Channel Code',
    selectChannel: 'Select Channel', selectCurrency: 'Select Currency',
    accountId: 'Account ID', recipientId: 'Recipient ID', orderId: 'Order ID',
    requestId: 'Request ID', externalUserId: 'External User ID',
    externalOrderId: 'External Order ID', userType: 'User Type',
    paymentMethod: 'Payment Method', firstName: 'First Name', middleName: 'Middle Name',
    lastName: 'Last Name', phone: 'Phone', dob: 'Date of Birth', email: 'Email',
    depositMethod: 'Deposit Method', withdrawMethod: 'Withdraw Method',
    callbackUrl: 'Callback URL', accountName: 'Account Name', bic: 'BIC/SWIFT',
    accountNumber: 'Account Number', bankName: 'Bank Name', purpose: 'Purpose',
    bankCountry: 'Bank Country',
    fullName: 'Full Name', bankIdentifier: 'Bank Identifier', virtualAccountName: 'Virtual Account Name',
    ninNumber: 'NIN Number', bvnNumber: 'BVN Number', mobile: 'Mobile',
    country: 'Country', city: 'City', street: 'Street', number: 'Street Number', postalCode: 'Postal Code',
    corporateType: 'Corporate Type', idType: 'ID Type', idNumber: 'ID Number',
    nationality: 'Nationality', residenceCountry: 'Residence/Registration Country',
    residenceCity: 'Residence/Registration City', residenceAddress: 'Residence/Registration Address',
    pixKeyType: 'PIX Key Type', targetCurrency: 'Target Currency', targetAmount: 'Target Amount',
    calOrigin: 'Calculation Direction', rateId: 'Rate ID', description: 'Transfer Description',
    pobo: 'POBO', chargeType: 'Charge Type', name: 'User Name', orderType: 'Order Type', orderStatus: 'Order Status',
    businessType: 'Business Type', transTime: 'Transaction Time', refund: 'Refund',
    timeRange: 'Time Range', allStatuses: 'All Statuses',
    basicConfig: 'Basic Config', queryConditions: 'Query Conditions', queryResults: 'Query Results',

    // Test Types
    ACCOUNT_CREATE: 'Account Create', PAYIN: 'Deposit', PAYOUT: 'Withdraw',
    CARD_BIND: 'Card Bind', QUERY: 'Query', CALLBACK: 'Callback',
    deposit: 'Deposit', withdraw: 'Withdraw',

    // Result & Status
    executionResult: 'Execution Result', status: 'Status', costTime: 'Cost Time',
    httpStatus: 'HTTP Status', traceId: 'Trace ID', channelOrderId: 'Channel Order ID',
    errorMsg: 'Error Message', errorCode: 'Error Code', errorDetail: 'Error Detail',
    request: 'Request', response: 'Response', subStatus: 'Sub Status',
    fee: 'Fee', createTime: 'Create Time', updateTime: 'Update Time',
    completedTime: 'Completed Time', refundStatus: 'Refund Status',

    // Execution History
    executionId: 'Execution ID', executor: 'Executor', executionTime: 'Execution Time',
    filterConditions: 'Filters', startTime: 'Start Time', endTime: 'End Time',
    executionDetail: 'Execution Detail', requestParams: 'Request Params', responseResult: 'Response',
    totalRecords: (n) => `Total ${n} records`,
    rangeRecords: (s, e, t) => `${s}-${e} of ${t} records`,

    // Messages
    loginSuccess: 'Login successful', loginFailed: 'Login failed',
    executeSuccess: 'Test executed successfully', executeFailed: 'Test execution failed',
    loadConfigFailed: 'Failed to load configuration', querySuccess: 'Query successful', queryFailed: 'Query failed',
    createSuccess: 'Created successfully', updateSuccess: 'Updated successfully', deleteSuccess: 'Deleted successfully',
    operationFailed: 'Operation failed', loadFailed: 'Load failed',
    bindSuccess: 'Bind successful', bindFailed: 'Bind failed',
    accountUnlocked: 'Account has been automatically unlocked',
    twoFAEnabled: '2FA enabled! Verification code will be required on next login',
    twoFADisabled: '2FA disabled',
    twoFAEnableFailed: 'Failed to enable 2FA', twoFAVerifyFailed: 'Verification failed',
    twoFADisableFailed: 'Failed to disable 2FA',

    // Validation
    usernameRequired: 'Please enter username', passwordRequired: 'Please enter password',
    pleaseInputChannelCode: 'Please select channel code', pleaseSelectTimeRange: 'Please select time range',
    pleaseInput: (field) => `Please enter ${field}`, pleaseSelect: (field) => `Please select ${field}`,
    autoGenerate: 'Leave blank to auto-generate',

    // Login Page
    accountLocked: 'Account Locked',
    accountLockedDesc: (min) => `Your account has been locked due to multiple failed login attempts. Please try again in ${min} minutes or contact an administrator.`,
    loginFailedTimes: (n) => `Login failed ${n} times`,
    remainingAttempts: (n) => `${n} attempts remaining, account will be locked for 15 minutes after 5 failures`,
    twoFAVerification: 'Two-Factor Verification',
    twoFADesc: 'Please open your authenticator app and enter the 6-digit code',
    securityTip: 'Security Tips',
    securityTipDesc: '• Password must be at least 8 characters with uppercase, lowercase, numbers and special characters\n• Account will be locked for 15 minutes after 5 consecutive failed logins',
    lockedButton: (min) => `Account Locked (${min} min)`,
    loggingIn: 'Logging in...', verifying: 'Verifying...', verify: 'Verify',
    backToLogin: 'Back to Login', enterCaptcha: 'Enter captcha',
    backToConsole: 'Back to Console',
    captchaRequired: 'Please enter captcha', enter6DigitCode: 'Please enter 6-digit code',
    require2FA: 'Please enter two-factor verification code',

    // Account Create
    accountCreateParams: 'Account Parameters',
    accountCreateSuccess: 'Account created', accountCreateFailed: 'Account creation failed',
    creatingAccount: 'Creating...', createAccount: 'Create Account',
    accountCreateResult: 'Account Result', submitToShowResult: 'Submit the form to see the result',
    selectChannelFirst: 'Please select a channel first', noChannelConfig: 'No configuration for this channel',

    // Payin
    payinParams: 'Deposit Parameters', payinSuccess: 'Deposit request submitted', payinFailed: 'Deposit failed',
    paying: 'Processing...', submitPayin: 'Submit Deposit', payinResult: 'Deposit Result',
    submitToShowPayinResult: 'Submit the form to see the deposit result',
    switchChannel: 'Switch Channel',

    // Payout
    payoutParams: 'Withdraw Parameters', payoutSuccess: 'Withdraw request submitted', payoutFailed: 'Withdraw failed',
    payingOut: 'Processing...', submitPayout: 'Submit Withdraw', payoutResult: 'Withdraw Result',
    submitToShowPayoutResult: 'Submit the form to see the withdraw result',
    extParams: 'Extended Parameters',

    // Bank Card Bind
    channelConfig: 'Channel Config', accountHolder: 'Account Holder',
    bankAccountInfo: 'Bank Account Info', holderType: 'Holder Type',
    accountType: 'Account Type', binding: 'Binding...', bindBankAccount: 'Bind Bank Account',
    bindResult: 'Bind Result', submitToShowBindResult: 'Submit the form to see the bind result',
    noAccountData: 'No accounts found, please create an account first',
    noCardData: 'No cards found, please bind a bank account first',

    // Query Common
    enterToQuery: (field) => `Enter ${field} to query`,
    resetBtn: 'Reset',

    // Account Query
    accountStatus: 'Account Status', accountDetail: 'Account Detail',
    bankAccountInfo2: 'Bank Account Info', operationTimeline: 'Operation Timeline',
    accountUpdated: 'Account Updated', accountCreated: 'Account Created',
    enterAccountId: 'Enter Account ID to query',

    // Payin Order Query
    payinOrderId: 'Deposit Order ID', payinStatus: 'Deposit Status',
    payinOrderDetail: 'Deposit Order Detail', payinOrderTimeline: 'Deposit Order Timeline',
    payinCompleted: 'Deposit Completed', payinProcessing: 'Deposit Processing',
    orderCreated: 'Order Created', callbackConfig: 'Callback Config',
    successRedirect: 'Success Redirect', failRedirect: 'Fail Redirect',
    enterPayinOrderId: 'Enter Deposit Order ID to query',
    channelPayinOrderId: 'Channel Deposit Order ID',

    // Payout Order Query
    payoutOrderId: 'Withdraw Order ID', payoutStatus: 'Withdraw Status',
    payoutAmount: 'Withdraw Amount', payoutOrderDetail: 'Withdraw Order Detail',
    payoutOrderTimeline: 'Withdraw Order Timeline', payoutCompleted: 'Withdraw Completed',
    payoutProcessing: 'Withdraw Processing', externalPayoutOrderId: 'External Withdraw Order ID',
    channelPayoutOrderId: 'Channel Withdraw Order ID',
    enterPayoutOrderId: 'Enter Withdraw Order ID to query',

    // Refund
    refundPage: 'Refund', refundQuery: 'Refund Order Query',
    refundParams: 'Refund Parameters', refundSuccess: 'Refund request submitted', refundFailed: 'Refund failed',
    refunding: 'Processing...', submitRefund: 'Submit Refund', refundResult: 'Refund Result',
    submitToShowRefundResult: 'Submit the form to see the refund result',
    depositOrderId: 'Deposit Order ID',

    // Refund Order Query
    refundOrderId: 'Refund Order ID', refundQueryStatus: 'Refund Status',
    refundAmount: 'Refund Amount', refundOrderDetail: 'Refund Order Detail',
    refundOrderTimeline: 'Refund Order Timeline', refundCompleted: 'Refund Completed',
    refundProcessing: 'Refund Processing', externalRefundOrderId: 'External Refund Order ID',
    channelRefundOrderId: 'Channel Refund Order ID',
    enterRefundOrderId: 'Enter Refund Order ID to query',

    // Bank Account Query
    bankAccountDetail: 'Bank Account Detail',
    enterRecipientId: 'Enter Recipient ID to query',
    queryBankAccount: 'Query Bank Account',

    // Order List
    totalCount: (n) => `Total ${n} records`,

    // Dashboard
    totalExecutions: 'Total Executions', successRate: 'Success Rate', avgResponseTime: 'Avg Response Time',
    todayExecutions: 'Today', successCount: 'Success', failedCount: 'Failed',
    testTypeDistribution: 'Test Type Distribution', channelDistribution: 'Channel Distribution',
    statusDistribution: 'Status Distribution', dailyTrend: 'Daily Execution Trend (Last 30 Days)',
    responseTimeDistribution: 'Response Time Distribution', channelSuccessRate: 'Channel Success Rate',
    channelTestTypeHeatmap: 'Channel × Test Type', executorLeaderboard: 'Executor Leaderboard',
    channelGlobalMap: 'Channel Global Distribution',
    exportReport: 'Export Report', lockLayout: 'Lock Layout', unlock: 'Unlock Layout',
    currencyDistribution: 'Currency Distribution', envDistribution: 'Environment Distribution',
    pvUvTrend: 'PV/UV Trend (30 Days)', hourlyDistribution: 'Hourly Distribution',
    channelStatusDistribution: 'Channel × Status', channelRadar: 'Channel Radar',
    recentExecutions: 'Recent Executions',
    noData: 'No execution data yet',

    // User Management
    userId: 'User ID', role: 'Role', userStatus: 'Status',
    channelPermissions: 'Channel Permissions', noPermission: 'No Permission', allPermissions: 'Full Access',
    admin: 'Admin', normalUser: 'User',
    internalUser: 'Internal', externalUser: 'External',
    active: 'Active', disabled: 'Disabled',
    createUser: 'Create User', editUser: 'Edit User',
    confirmDelete: 'Confirm deactivate this user?', confirmActivate: 'Confirm reactivate this user?',
    deactivate: 'Deactivate', activate: 'Activate',
    deactivateSuccess: 'User deactivated', activateSuccess: 'User activated',
    passwordStrengthWeak: 'Weak', passwordStrengthMedium: 'Medium', passwordStrengthStrong: 'Strong',
    passwordRequirements: 'Password: 8-32 chars, must include uppercase, lowercase, number and special character',
    atLeast8Chars: 'At least 8 characters', includeUppercase: 'Include uppercase letter',
    includeLowercase: 'Include lowercase letter', includeNumber: 'Include number',
    includeSpecial: 'Include special character',
    uidTooltip: 'Auto-generated, format: U+date+sequence',
    usernameMin3: 'Username must be at least 3 characters',
    passwordMin8: 'Password must be at least 8 characters', passwordMax32: 'Password must be at most 32 characters',
    passwordMustUppercase: 'Password must contain uppercase letter',
    passwordMustLowercase: 'Password must contain lowercase letter',
    passwordMustNumber: 'Password must contain number',
    passwordMustSpecial: 'Password must contain special character (!@#$%^&*(),.?":{}|<>_-)',
    checkForm: 'Please check the form',
    loadUsersFailed: 'Failed to load user list',

    // Channel Account Management
    clientType: 'Client Type', localAccountNo: 'Local Account No.', channelAccountNo: 'Channel Account No.',
    customerId: 'Customer ID', priority: 'Priority', copyToDemo: 'Copy to DEMO_ACCOUNT',
    allChannels: 'All Channels',
    cloneToDemo: 'Clone to DEMO_ACCOUNT?',
    confirmDisableAccount: 'Disable',
    confirmEnableAccount: 'Enable',
    endpoint: 'Endpoint',
    timeoutMs: 'Timeout(ms)',
    signAlgorithm: 'Sign Algorithm',
    selectAlgorithm: 'Select Algorithm',
    channelPublicKey: 'Channel Public Key',
    extraConfig: 'Extra Config',
    security: 'Security',

    // Channel User Management
    channelUserManagement: 'Channel User Management',
    createUserTab: 'Create User',
    queryUserTab: 'Query User',
    basicInfo: 'Basic Info',
    channelLabel: 'Channel',
    selectChannelPlaceholder: 'Select Channel',
    userTypeLabel: 'User Type',
    individualUser: 'INDIVIDUAL',
    businessUser: 'BUSINESS',
    externalUserIdLabel: 'External User ID',
    pleaseInputExternalUserId: 'Please enter External User ID',
    currencyLabel: 'Currency',
    selectCurrencyPlaceholder: 'Select Currency',
    extParamSection: 'Extended Parameters',
    extParamTooltip: 'Channel extended parameters in JSON format',
    createUserBtn: 'Create User',
    creatingUser: 'Creating...',
    createResultTitle: 'Create Result',
    submitToShowCreateResult: 'Submit the form to see the result',
    queryConditionsSection: 'Query Conditions',
    externalUserIdTooltip: 'At least one of externalUserId or userId is required',
    userIdLabel: 'User ID',
    userIdTooltip: 'fiat-payment internal user ID',
    queryUserBtn: 'Query User',
    queryingUser: 'Querying...',
    queryResultTitle: 'Query Result',
    submitToShowQueryResult: 'Submit query to see the result',
    userCreateSubmitted: 'User creation request submitted',
    userCreateFailed: 'Creation failed',
    userQueryFailed: 'Query failed',
    unknownError: 'Unknown error',
    // Tazapay KYB
    tzCompanyBasicInfo: 'Company Basic Info',
    tzIndustry: 'Industry',
    tzIndustryRequired: 'Required, will be rejected by channel if empty',
    tzTaxId: 'Tax ID',
    tzPhoneLabel: 'Phone',
    tzPhoneCode: 'Phone Code',
    tzWebsite: 'Website',
    tzBusinessDesc: 'Business Description',
    tzKybCompanyInfo: 'KYB Company Info',
    tzCompanyTypeLabel: 'Company Type',
    tzCompanyNameLabel: 'Company Name',
    tzRegNo: 'Registration No.',
    tzEstablishDate: 'Establish Date',
    tzSelectDate: 'Select Date',
    tzStatementDesc: 'Statement Descriptor',
    tzRegisterAddress: 'Registered Address',
    tzOperationAddress: 'Operation Address',
    tzCompanyDocs: 'Company Documents',
    tzFileType: 'File Type',
    tzLinkedFile: 'Linked File',
    tzSelectUploadedFile: 'Select uploaded file',
    tzFileName: 'File Name',
    tzFileDesc: 'Description',
    tzAddDoc: 'Add Document',
    tzLegalInfo: 'Legal Representative Info',
    tzRepresentative: 'Representative',
    tzFirstName: 'First Name',
    tzLastName: 'Last Name',
    tzNationality: 'Nationality',
    tzDob: 'Date of Birth',
    tzSelectDob: 'Please select date of birth',
    tzRole: 'Role',
    tzOwnership: 'Ownership %',
    tzResidentialAddress: 'Residential Address',
    tzRepDocs: 'Representative Documents',
    tzAddRepDoc: 'Add Document',
    tzAddRepresentative: 'Add Representative',
    tzTransactionProfile: 'Transaction Profile (Optional)',
    tzMonthlyValue: 'Monthly Value',
    tzMonthlyVolume: 'Monthly Volume',
    tzCountries: 'Countries',
    tzRiskLevel: 'Risk Level',
    tzAddressCountry: 'Country',
    tzAddressState: 'State/Province',
    tzAddressCity: 'City',
    tzAddressPostcode: 'Postal Code',
    tzAddressLine1: 'Address Line 1',

    // Quote (Rate Query)
    quoteTitle: 'Rate Query',
    quoteBasicInfo: 'Basic Info',
    quoteOriginCurrency: 'Origin Currency',
    quoteTargetCurrency: 'Target Currency',
    quotePayeeType: 'Payee Type',
    quoteAmount: 'Amount (minor units)',
    quoteAmountTip: 'Amount in minor currency units (e.g. cents)',
    quoteUserInfo: 'User Info',
    quoteUserId: 'User ID',
    quoteUserIdTip: 'Required when payeeType=BENEFICIARY',
    quoteExternalUserId: 'External User ID',
    quoteAdvanced: 'Advanced Options',
    quoteDestCountry: 'Destination Country',
    quoteLocalNetwork: 'Local Payment Network',
    quoteFundNetwork: 'Fund Transfer Network',
    quoteQueryBtn: 'Query Rate',
    quoteResultTitle: 'Query Result',
    quoteExchangeRate: 'Exchange Rate',
    quoteExpireTime: 'Expires At',
    quoteEmptyHint: 'Submit query to see rate result',

    // Bank Bind Extended Params
    recipientAddress: 'Recipient Address', recipientCity: 'Recipient City',
    recipientPostalCode: 'Recipient Postal Code', recipientCountry: 'Recipient Country',
    routeAba: 'Route ABA', routeType: 'Route Type',
    payeeType: 'Payee Type', payeeCompanyName: 'Payee Company Name',
    payeeEmail: 'Payee Email', payeePhone: 'Payee Phone',
    payeeCountry: 'Payee Country', payeeStreetAddress: 'Payee Street Address',
    payeeCity: 'Payee City', bankAddress: 'Bank Address', bankCity: 'Bank City',
    bankState: 'Bank State', branchCode: 'Branch Code', bankCode: 'Bank Code',
    contactDocuments: 'Contact Documents', bankStatement: 'Bank Statement',
    clearingNetwork: 'Clearing Network', financialInstitution: 'Financial Institution (BIC)',
    creditorAddressLine1: 'Creditor Address',
    rfc: 'RFC Tax ID', numericRef: 'Numeric Reference', notesRef: 'Notes Reference',

    // Field Tooltip Tips
    tipBusinessName: 'For BUSINESS, use company name split',
    tipDobFormat: 'Format: ddMMyyyy',
    tipIdType: 'P=Passport N=ID Card (INDIVIDUAL only)',
    tip3LetterCountry: '3-letter country code',
    tipCorporateType: 'Required for BUSINESS only',
    tipBankIdentifierFromCard: 'Obtain from card list',
    tipBankIdentifierFromList: 'Obtain from bank list',
    tipVirtualAccountName: 'Custom VA name, required',
    tipKycKybName: 'KYC: personal name; KYB: company name',
    tipNinNumber: 'Used for personal_nin type, must be 11 digits',
    tipBvnNumber: 'KYC: own BVN; KYB: director BVN, must be 11 digits',
    tipVaDisplayName: 'VA account display name',
    tipEmailOrMobile: 'At least one of email or mobile required',
    tipBitsoVirtualAccount: 'BITSO supports VIRTUAL_ACCOUNT only',
    tipRecipientIdFromPayment: 'recipientId returned by fiat-payment',
    tipRecipientIdFromBind: 'recipientId returned from card binding',
    tipPurposeLength3: 'Withdrawal purpose, must be exactly 3 chars',
    tipDescriptionMax32: 'Max 32 characters',
    tipCalOrigin: 'TARGET2ORIGIN: received=targetAmount; ORIGIN2TARGET: paid=amount',
    tipRateId: 'Required for cross-currency',
    tipDescriptionMax100: 'Max 100 characters',
    tipPobo: 'RTGS only; Y means payee name shows as self',
    tipChargeType: 'BEN: payee bears; OUR: payer bears; SHA: shared',
    tipBitsoWithdrawMethod: 'BITSO supports BANK_TRANSFER only',
    tipRfc: 'Payee tax ID, required',
    tipNumericRef: 'Optional, max 7 digits',
    tipNotesRef: 'Optional, max 40 characters',
    tipPixKeyOrBankCode: 'PIX Key or bank code',
    tipClabe: 'CLABE must be 18 digits, required',
    tipClabeByProtocol: (p) => p === 'debitcard' ? 'Enter debit card number' : p === 'phonenum' ? 'Enter phone number' : 'CLABE must be 18 digits',
    tipProtocol: 'Default: clabe; debitcard=debit card; phonenum=phone number',
    tipBankCodeDebitcard: 'Required when protocol=debitcard or phonenum',

    // Inswitch Tips
    tipInswitchVirtualAccount: 'VIRTUAL_ACCOUNT only, BRL only',
    tipInswitchIdType: 'INDIVIDUAL: CPF (Brazilian personal tax ID); BUSINESS: CNPJ (Brazilian company tax ID)',
    tipInswitchDocNumber: 'INDIVIDUAL: CPF number (11 digits); BUSINESS: CNPJ number (14 digits)',
    tipInswitchBirthDate: 'INDIVIDUAL: date of birth; BUSINESS: company registration date. Format: YYYY-MM-DD (e.g. 1994-08-15)',
    tipInswitchCountryCode2: 'INDIVIDUAL: birth country; BUSINESS: company registration country. 2-letter uppercase code (e.g. BR)',
    tipInswitchCompanyName: 'Required for BUSINESS, not needed for INDIVIDUAL',
    tipInswitchCompanyType: 'Required for BUSINESS, not needed for INDIVIDUAL. Values: Professional Services and Consulting / Technology and Digital Platforms / Commerce, Import/Export, and E-commerce / Logistics, Transportation, and Related Services / Education, Entertainment, and Miscellaneous Services / Financial Transactions and Investments',
    tipInswitchWithdrawMethod: 'PIX_CODE only',
    tipInswitchPixKey: 'PIX payment identifier, required. Can be email / CPF / phone / UUID random key',
    tipInswitchDepositDocType: 'INSWITCH supports BRL and MXN only. BRL: CPF (individual) / CNPJ (company); MXN: ruc (RFC tax ID)',
    tipInswitchDepositDocNumber: 'BRL: CPF 11 digits / CNPJ 14 digits; MXN: RFC tax ID (channel regex validated)',
    tipInswitchDepositName: 'Required for BRL (name regex); required for MXN when entityType=naturalPerson',
    tipInswitchEntityType: 'Required for MXN: naturalPerson (needs firstName/lastName) / legalEntity (needs companyName/companyType)',
    tipInswitchClabe: 'MXN SPEI core payee identifier, 18-digit CLABE account, required',
    tipInswitchNameRule: 'Account create: required for INDIVIDUAL, optional for BUSINESS. Withdraw: always required. Match pattern: ^[A-Za-z âÂãÃāĀÁáçÇêÊÉéÍíÕõÔôÓóÚúÀàÈèÌìÒòÙùǸǹẀẁỲỳñÑüÜ.\']+$ (Portuguese special chars supported)',
    tipInswitchSecondLastname: 'Optional, second last name (common in Latin America). Match pattern: same as name fields',
    tipInswitchEmail: 'Optional. Match pattern: ^[0-9A-Za-z\\-_\\.]+@([0-9A-Za-z\\-_]+\\.)+[0-9A-Za-z\\-_]{2,5}$',
    tipInswitchPhone: 'Optional, digits only. Match pattern: ^\\d{4,15}$ (4-15 digits)',
    tipInswitchAddress: 'INDIVIDUAL: residential address; BUSINESS: registered address. Match pattern: ^[0-9A-Za-z âÂãÃ...ñÑüÜ.,\']+$ (digits, letters, Portuguese chars, punctuation)',
    tipInswitchWithdrawAmount: 'Must be > 0, up to 2 decimal places',
    tipInswitchCallbackUrl: 'Required for withdraw',

    birthDate: 'Birth Date', birthCountry: 'Birth Country', address: 'Address',
    countryCode: 'Country Code', companyName: 'Company Name', companyType: 'Company Type',
    documentType: 'Document Type', documentNumber: 'Document Number', pixKey: 'PIX Key',
    secondLastname: 'Second Last Name', email: 'Email', phoneNumber: 'Phone Number',

    // BITSO fields
    protocol: 'Protocol', clabe: 'CLABE No.', bankCode: 'Bank Code',
    clabeAccountNo: 'CLABE / Card No. / Phone No.',

    // 2FA
    enable2FA: 'Enable Two-Factor Auth', disable2FA: 'Disable Two-Factor Auth',
    twoFATitle: 'Enable Two-Factor Authentication (2FA)',
    twoFAScanDesc: 'Please use Google Authenticator or another TOTP app to scan the QR code',
    twoFAStep1: 'Step 1: Scan the QR code with Google Authenticator or another TOTP app',
    twoFAStep2: 'Step 2: Enter the 6-digit code shown in the app',
    manualKey: 'Secret Key (manual entry)', manualKeyDesc: 'Secret Key (if unable to scan, enter manually)',
    verifyAndEnable: 'Verify & Enable', confirmDisable: 'Confirm Disable',
    twoFAProtection: 'Two-factor authentication provides extra security for your account. Once enabled, you will need to enter a 6-digit code from your authenticator app when logging in.',
    twoFARecommend: 'Recommended apps: Google Authenticator, Microsoft Authenticator, Authy',
    twoFAEnabled2: 'Enabled', twoFADisabled2: 'Not Enabled',
    disableTwoFADesc: 'Disabling two-factor authentication will reduce your account security. Please enter your current 6-digit code to confirm.',
    enter6Code: 'Please enter 6-digit code',
    // SenderInfo
    senderInfo: 'Sender Info',
    senderIban: 'Sender Account (IBAN)',
    senderAcctName: 'Sender Account Name',
    senderBic: 'Sender Bank (BIC)',
    paymentInfo: 'Payment Info',
    openPaymentPage: 'Open Payment Page',
    scanToPay: 'Scan QR code to pay',

    // Mock Rules
    mockRules: 'Mock Rules',
    mockRuleTotal: 'Total Rules',
    mockRuleEnabled: 'Enabled',
    mockRuleDisabled: 'Disabled',
    mockRuleChannels: 'Channels',
    mockRuleFilterChannel: 'Filter by Channel',
    mockRuleSearchPlaceholder: 'Search path / description...',
    mockRuleRefreshCache: 'Refresh Cache',
    mockRuleNewRule: 'New Rule',
    mockRuleEditRule: 'Edit Rule',
    mockRuleCreateRule: 'Create Rule',
    mockRulePathPattern: 'Path Pattern (regex)',
    mockRuleDescription: 'Description',
    mockRuleHttpStatus: 'HTTP Status',
    mockRulePriority: 'Priority',
    mockRuleExpireTime: 'Expire Time',
    mockRuleNeverExpire: 'Never',
    mockRuleMockResponse: 'Mock Response (JSON)',
    mockRuleResponsePreview: 'Response Preview',
    mockRuleActions: 'Actions',
    mockRuleDuplicate: 'Duplicate',
    mockRuleConfirmDelete: 'Delete this rule?',
    mockRuleTotalRules: (n) => `Total ${n} rules`,
    mockRuleNoData: 'No mock rules configured',
  },
};

// Merge API doc translations
export const translations = {
  'zh-CN': { ...baseTranslations['zh-CN'], ...apiDocTranslations['zh-CN'] },
  'en-US': { ...baseTranslations['en-US'], ...apiDocTranslations['en-US'] },
};

export const getLanguageByIP = async () => {
  try {
    const response = await fetch('https://ipapi.co/json/');
    const data = await response.json();
    const languageMap = { 'CN': 'zh-CN', 'US': 'en-US', 'GB': 'en-US' };
    return languageMap[data.country_code] || 'en-US';
  } catch {
    const browserLang = navigator.language || navigator.userLanguage;
    if (browserLang.startsWith('zh')) return 'zh-CN';
    return 'en-US';
  }
};
